export const sizes = {
    x2: '8px',
    x3: '12px',
    x4: '16px',
    x5: '20px',
    x6: '24px',
    x7: '28px',
    x8: '32px',
    x9: '36px',
    x10: '40px',
    x11: '44px',
    x12: '48px',
    x13: '52px',
    x14: '56px',
    x16: '64px',
    x24: '96px',
    x30: '120px',
    x50: '200px',
    x56: '224px',
    x59: '236px',
    x60: '240px',
    x74: '296px',
    x80: '320px',
    x100: '400px',
    x120: '480px',
};
//# sourceMappingURL=sizing.js.map